/* @flow */
import React from 'react';
import gql from 'graphql-tag';
import Experiment from '@homeaway/react-experiment';
import {DestinationMessage as DestinationMessageComponent} from '@homeaway/react-urgency-messaging';
import {HA_SERP_DESTINATION_URGENCY_MSG} from '../../abacus/experiments';

import type DestinationMessage from '@homeaway/graphql-traveler-urgency-messaging';

export const fragments = {
    results: gql`
        fragment DestinationMessageResults on Results {
            urgencyDestinationMessage {
                iconTitleTextV3 {
                    title
                    message
                    icon
                }
                iconTextV1 {
                    message
                    icon
                }
            }
        }
    `
};

export function Content(destinationMessage: DestinationMessage) {
    return (
        <Experiment name={HA_SERP_DESTINATION_URGENCY_MSG} variant={1}>
            <DestinationMessageComponent
                destinationMessage={destinationMessage}
                size={'l'}
            />
        </Experiment>
    );
}
